import * as actionTypes from "../../constants/actionTypes";
import * as methods from "../../constants/methods";
import * as handlers from "../../constants/handlers";
import * as resultCodes from "../../constants/resultCodes";
import * as componentTypes from "../../constants/componentTypes";
import * as messageHelper from "../../helpers/messageHelper";

export const processWebsocketResponse = (tabId, method, response) => {
    switch (method) {
        case handlers.MACHINE_GET_AUTOTASKS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_AUTOTASK_LIST,
                    payload: {
                        autotaskList: response.data
                    }
                }
            ];
        case handlers.MACHINE_START_AUTOTASK:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_RCC_ASYNC_RESPONSE,
                    payload: {
                        id: response.sequence,
                        tabId: 0,
                        method: methods.MACHINE_EVENT_AUTOTASK_DONE
                    }
                }
            ];
        case handlers.MACHINE_AUTOTASK_DELETE:
        case handlers.MACHINE_AUTOTASK_ADD_GENERIC:
        case handlers.MACHINE_AUTOTASK_UPDATE_GENERIC:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.NAVIGATION_CLOSE_MODAL,
                    payload: {
                        type: componentTypes.AUTOTASK_MODAL
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_RCC_ACTION
                }
            ];
    }
};
